export enum AppEnv {
  LOCAL = "localhost",
  DEV = "dev",
  BETA = "beta",
  QA = "qa",
  PROD = "prod",
}
